export class Disclaimer {
    termsOfUse!: boolean;
    dataPrivacy!: boolean;
    volunteerRules!: boolean;
  }